function isDomainGood () {
  let host = location.host
  if (host === '') {
    return false
  }

  let blackListDomain = ['youhaovip.com', 'youhaosuda.com']
  for (let blackList of blackListDomain) {
    if (host.endsWith(blackList)) {
      return false
    }
  }
  return true
}

export {isDomainGood}



// WEBPACK FOOTER //
// ./src/common/util/isDomainGood.js